import React from 'react';
import { useCountDown } from 'ahooks';
interface CountDownTimerProps {
    targetDate?: string;
    onEnd?: () => void;  // 传入一个回调函数
}
const CountDownTimer: React.FC<CountDownTimerProps> = ({ targetDate,onEnd }) => {
    const [countdown] = useCountDown({
        targetDate,
        onEnd,
    });
    const seconds = Math.max(0, Math.ceil(countdown / 1000));

    return (
        <span style={{ whiteSpace: 'nowrap' }}>
            剩余时间:
            {String(Math.floor(seconds / 60)).padStart(2, '0')}:
            {String(seconds % 60).padStart(2, '0')}
        </span>
    );
};

export default CountDownTimer;
